<script lang="ts">
export default {
  name: 'VideoFrame',
  data () {
    return {
      src: '/images/VIDEO-2025-11-22-19-37-36.mp4',
      type: 'video/mp4',
      width: 450
    }
  }
}
</script>

<template>
  <video
    :key="src"
    :width="width"
    autoplay
    muted
    playsinline
    loop
  >
    <source
      :src="src"
      :type="type"
    >
  </video>
</template>

<style scoped>
video {
  width: 90%;
  height: auto; /* keeps correct aspect ratio */
}
</style>
